import axios, { AxiosResponse } from "axios";
import { updateTenantObj } from "../../../shared/interfaces/components/tenantList.interface";
import { ApiErrorHandler } from "../../../../errorHandler";
import { ErroObj } from "../../../shared/interfaces/model/errorObj.interface";
import apiClient from "../../shared/api/apiClient";
import {
  recoverResponseCode,
  recoverResponseData,
} from "../../../features/tenantList/pages/tenantList";

const correlationId = (): string => {
  const array = new Uint8Array(12);
  crypto.getRandomValues(array);
  return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join("");
};

export const getTenantDetail = (tenantId: string) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/tenant/${tenantId}`;
  return apiClient
    .get(URL)
    .then((response: AxiosResponse) => response.data)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};

export const getTenantsList = (id?: string) => {
  if (id !== undefined) {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const URL = `${baseUrl}/nexum-saas/tenant?last=${id}&sortBy=creationDate&sortType=desc`;
    return apiClient
      .get(URL)
      .then((response: AxiosResponse) => response.data)
      .catch((e: ErroObj) => {
        ApiErrorHandler(
          e.message,
          e.config.url,
          JSON.stringify(e.config.headers),
          e.config.method
        );
      });
  }

  // get single tenant
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/tenant`;
  return apiClient
    .get(URL)
    .then((response: AxiosResponse) => response.data)
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};

export const deleteTenant = (id: string) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/tenant/${id}`;
  return apiClient
    .delete(URL)
    .then((Response: AxiosResponse) => {
      recoverResponseCode(Response.status);
      recoverResponseData(Response.data);
    })
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};

export const updateTenant = (payload: updateTenantObj) => {
  const bodyRequest = {
    organizationName: payload.newOrgName,
    organizationEmail: payload.newOrgEmail,
    products: payload.newProduct,
    companyName: payload.newCompanyName,
    VAT: payload.newVAT,
    destinationCode: payload.newDestinationCode,
    pec: payload.newPec,
  };
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/tenant/${payload.id}`;
  return axios
    .patch(URL, bodyRequest)
    .then((Response: AxiosResponse) => {
      recoverResponseCode(Response.status);
      recoverResponseData(Response.data);
    })
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};

export const updateUser = (payload: updateTenantObj) => {
  const bodyRequest = {
    organizationName: `${payload.newName}${payload.newSurname}`,
    organizationEmail: payload.newEmail,
    products: payload.newProduct,
    companyName: `${payload.newName} ${payload.newSurname}`,
    VAT: "",
    destinationCode: "00000",
    pec: "",
    userData: {
      name: payload.newName,
      email: payload.newEmail,
      surname: payload.newSurname,
      city: payload.newCity,
      province: payload.newProvince,
      dateOfBirth: payload.newDateOfBirth,
      fiscalCode: payload.newFiscalCode,
      address: payload.newAddress,
      phoneNumber: payload.newPhoneNumber,
    }
  };
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const URL = `${baseUrl}/nexum-saas/tenant/${payload.id}`;
  return axios
    .patch(URL, bodyRequest)
    .then((Response: AxiosResponse) => {
      recoverResponseCode(Response.status);
      recoverResponseData(Response.data);
    })
    .catch((e: ErroObj) => {
      ApiErrorHandler(
        e.message,
        e.config.url,
        JSON.stringify(e.config.headers),
        e.config.method
      );
    });
};
